module.exports = __webpack_public_path__ + "fonts/4618f0de2a818e7ad3fe880e0b74d04a.ttf";